<template>
  <span style="width: 400px">
    <v-autocomplete
      v-debounce:700="getReservations"
      prepend-inner-icon="mdi-magnify"
      :label="$lang('main.navbar.search_reservation')"
      solo-inverted
      flat
      hide-details
      :items="reservations"
      item-value="id"
      item-text="client.name"
      :filter="item => item"
      :loading="request.loading"
    >
      <template v-slot:selection>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-icon>
          <v-icon
            v-if="item.status === $const('ConstReservationStatuses', 'CONFIRMED')"
            :title="$constText('ConstReservationStatuses', item.status)"
            color="success">mdi-check-circle
          </v-icon>
          <v-icon
            v-if="item.status === $const('ConstReservationStatuses', 'CANCELED')"
            :title="$constText('ConstReservationStatuses', item.status)"
            color="error">mdi-cancel
          </v-icon>
          <v-icon
            v-if="item.status === $const('ConstReservationStatuses', 'PENDING')"
            :title="$constText('ConstReservationStatuses', item.status)"
            color="warning">mdi-timer-sand
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content @click="openEditing(item.id)">
          <v-list-item-title>
            <span class="text-h6">{{item.client.name}}</span>
            - {{ $lang('reservations.fields.res_id') }}: {{item.res_id}}
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-icon small>mdi-office-building</v-icon> {{ item.property.name }}
            <v-icon small>mdi-bed</v-icon> {{ item.unit.name }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ $toDateFormat(item.start_date) }}
            <v-icon small>mdi-arrow-right</v-icon>
            {{ $toDateFormat(item.end_date) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ $lang('reservations.hints.search') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
    <v-dialog v-model="isOpenEditing" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <editing-form
        v-if="isOpenEditing"
        :item-id="activeId"
        @cancel="closeEditing"
        @error="failed"
        @success="updated"
      />
    </v-dialog>
  </span>
</template>

<script>
import { mapState } from "vuex";
import MixpanelEvents from "@/constants/events";
import { SEARCH_RESERVATIONS } from "@/store/reservations/actions";

import EditingForm from "@/pages/reservations/EditingForm";

export default {
	name: "SearchBox",
	components: {
		EditingForm
	},
	data() {
		return {
			search: null,
			activeId: null,
      isOpenEditing: false,
		};
	},
	methods: {
		openEditing(id) {
      this.$monitorService.track(MixpanelEvents.GLOBAL_SEARCH_ITEM_CLICKED);
			this.isOpenEditing = true;
			this.activeId = id;
		},
		closeEditing() {
			this.isOpenEditing = false;
			this.activeId = null;
    },
    updated() {
      this.closeEditing();
      this.showNotification(this.$lang("main.crud.success_update"), "success");
    },
    failed() {
      this.showNotification(this.$lang("main.crud.something_went_wrong"), "error");
    },
		getReservations(search) {
      if(!search || search.length <= 3) {
        return
      }

			this.$store.dispatch(SEARCH_RESERVATIONS, {
        search: search,
        from: this.$moment().subtract(1, 'months').format('YYYY-MM-DD'),
        _data: {
          selects: [
            "id",
            "start_date",
            "end_date",
            "res_id",
            "client_id",
            "property_id",
            "unit_id",
            "status",
          ],
          relations: {
            client: {
              selects: ["id", "name"]
            },
            property: {
              selects: ["id", "name"]
            },
            unit: {
              selects: ["id", "name"]
            },
          }
        }
      }).then(() => {       
        this.$monitorService.track(MixpanelEvents.GLOBAL_SEARCH_PERFORMED, {
          search_count: this.reservations.length,
        });
      });
    },
	},
	computed: {
    reservations() {
      if (this.request.loading) {
        return [];
      }
      return this.request.collection;
    },
		...mapState({
			request: state => state.reservations.getSearchRequest
		})
	},
};
</script>
